import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import { takeEvery, call, put } from "redux-saga/effects";

import _ from "lodash";
import {
  CREATE_GDOC_ASSET_EDITOR_REFERENCE_REQUEST,
  CREATING_GDOC_ASSET_EDITOR_REFERENCE_SUCCEDDED,
  CREATING_GDOC_ASSET_EDITOR_REFERENCE_FAILED,
  SYNC_GDOC_ASSET_EDITOR_REFERENCE_REQUEST,
  SYNCING_GDOC_ASSET_EDITOR_REFERENCE_SUCCEDDED,
  SYNCING_GDOC_ASSET_EDITOR_REFERENCE_FAILED,
  INVALIDATE_GDOC_ASSET_EDITOR_REFERENCE
} from "./actionTypes";
import {
  CreateGDocIntegrationRequest,
  CreatingGDocIntegrationErrorResponse,
  CreatingGDocIntegrationResponse,
  SyncGDocIntegrationRequest,
  SyncingGDocIntegrationErrorResponse,
  SyncingGDocIntegrationResponse,
} from "src/types/gDocIntegration";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_API_URL}`;
const GDOCS_API_URL = `${apiUrl}/api/2.0/assets/gdocs`;

export const createGDocEditorReference =
  createAction<CreateGDocIntegrationRequest>(
    CREATE_GDOC_ASSET_EDITOR_REFERENCE_REQUEST,
  );

const creatingGDocEditorReferenceSucceeded =
  createAction<CreatingGDocIntegrationResponse>(
    CREATING_GDOC_ASSET_EDITOR_REFERENCE_SUCCEDDED,
  );

const creatingGDocEditorReferenceFailed =
  createAction<CreatingGDocIntegrationErrorResponse>(
    CREATING_GDOC_ASSET_EDITOR_REFERENCE_FAILED,
  );

const createGDocEditorReferenceSaga = function* (
  action: ReturnType<typeof createGDocEditorReference>,
): any {
  const assetId = action.payload.assetId;

  const createGDocEditorReferenceAPI = () => {
    return axios({
      method: "POST",
      url: `${GDOCS_API_URL}/${assetId}`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createGDocEditorReferenceAPI);
    yield put(creatingGDocEditorReferenceSucceeded(response));
  } catch (error) {
    yield put(creatingGDocEditorReferenceFailed({ error: error }));
  }
};

export const syncGDocEditorReference = createAction<SyncGDocIntegrationRequest>(
  SYNC_GDOC_ASSET_EDITOR_REFERENCE_REQUEST,
);

const syncingGDocEditorReferenceSucceeded =
  createAction<SyncingGDocIntegrationResponse>(
    SYNCING_GDOC_ASSET_EDITOR_REFERENCE_SUCCEDDED,
  );

const syncingGDocEditorReferenceFailed =
  createAction<SyncingGDocIntegrationErrorResponse>(
    SYNCING_GDOC_ASSET_EDITOR_REFERENCE_FAILED,
  );

const syncGDocEditorReferenceSaga = function* (
  action: ReturnType<typeof syncGDocEditorReference>,
): any {
  const assetId = action.payload.assetId;

  const syncGDocEditorReferenceAPI = () => {
    return axios({
      method: "POST",
      url: `${GDOCS_API_URL}/${assetId}`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(syncGDocEditorReferenceAPI);
    yield put(syncingGDocEditorReferenceSucceeded(response));
  } catch (error) {
    yield put(syncingGDocEditorReferenceFailed({ error: error }));
  }
};

export const invalidateGDocEditorReference = createAction<void>(INVALIDATE_GDOC_ASSET_EDITOR_REFERENCE);


export default function* gDocIntegrationSaga() {
  yield takeEvery(
    CREATE_GDOC_ASSET_EDITOR_REFERENCE_REQUEST,
    createGDocEditorReferenceSaga,
  );
  yield takeEvery(
    SYNC_GDOC_ASSET_EDITOR_REFERENCE_REQUEST,
    syncGDocEditorReferenceSaga,
  );
}
